'use client';

import React from 'react';
import { CatButton } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import { useDealerLocatorDrawer } from 'components/dealer-locator/dealer-locator-drawer-context';
import {
  GA_CHECK_PRICE,
  GA_PDP_LIST_VIEW_FOOTER_SECTION,
  GA_PRIMARY_CTA
} from 'constants/analyticsConstants';

interface PartsCheckPriceProps {
  classNames?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  variant?: 'inline' | 'primary' | 'contrast' | 'danger' | 'ghost';
  onClick?: () => void;
  fullWidth?: boolean;
}
const PartsCheckPrice = ({
  classNames = 'mb-1',
  ...props
}: PartsCheckPriceProps) => {
  const t = useTranslations();
  const drawerControl = useDealerLocatorDrawer();

  return (
    <CatButton
      size="sm"
      variant="contrast"
      onClick={() => drawerControl.openDrawer()}
      className={classNames}
      {...props}
      data-track-event={GA_PRIMARY_CTA}
      data-track-attr-nltext={GA_CHECK_PRICE}
      data-track-attr-context={GA_PDP_LIST_VIEW_FOOTER_SECTION}
    >
      {t('CAT_CHECK_PRICE')}
    </CatButton>
  );
};

export default PartsCheckPrice;
